export default __webpack_public_path__ + "static/media/outdoorLiving.fe6f1bd3.jpg";